import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const api = {
  // Auth
  login: (email, password) => client.post("/auth/login", { email, password }).then(r => r.data),
  logout: () => client.post("/auth/logout").then(r => r.data),
  me: () => client.get("/auth/me").then(r => r.data),
  changePassword: (old_password, new_password) => client.post("/auth/change-password", { old_password, new_password }).then(r => r.data),

  // Public content
  getContent: (site = "refuge") => client.get(`/content?site=${site}`).then(r => r.data),
  getPricing: (site = "refuge") => client.get(`/pricing?site=${site}`).then(r => r.data),
  getReviews: (site = "refuge") => client.get(`/reviews?site=${site}`).then(r => r.data),
  getContact: (site = "refuge") => client.get(`/contact?site=${site}`).then(r => r.data),
  getSites: () => client.get(`/sites`).then(r => r.data),
  getMediaManifest: (site = "refuge") => client.get(`/media/manifest?site=${site}`).then(r => r.data),

  // Admin write
  putContent: (site, data) => client.put("/admin/content", { site, data }).then(r => r.data),
  putPricing: (site, data) => client.put("/admin/pricing", { site, data }).then(r => r.data),
  putContact: (site, data) => client.put("/admin/contact", { site, data }).then(r => r.data),
  addReview: (r) => client.post("/admin/reviews", r).then(x => x.data),
  editReview: (id, r) => client.put(`/admin/reviews/${id}`, r).then(x => x.data),
  delReview: (id) => client.delete(`/admin/reviews/${id}`).then(r => r.data),
  putStats: (site, stats) => client.put("/admin/review-stats", { site, stats }).then(r => r.data),

  // Media
  listMedia: (site = "refuge") => client.get(`/admin/media?site=${site}`).then(r => r.data),
  uploadMedia: (file, filename, site = "refuge") => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("filename", filename);
    fd.append("site", site);
    return axios.post(`${API}/admin/media`, fd, { withCredentials: true }).then(r => r.data);
  },
  delMedia: (filename) => client.delete(`/admin/media/${filename}`).then(r => r.data),

  // Gift cards
  createGiftCard: (payload) => client.post("/gift-cards", payload).then(r => r.data),
  getGiftCard: (code) => client.get(`/gift-cards/${code}`).then(r => r.data),
  listGiftCards: (site = "refuge") => client.get(`/admin/gift-cards?site=${site}`).then(r => r.data),
  patchGiftCard: (code, patch) => client.patch(`/admin/gift-cards/${code}`, patch).then(r => r.data),
  delGiftCard: (code) => client.delete(`/admin/gift-cards/${code}`).then(r => r.data),

  // History + export
  getHistory: (site = "refuge") => client.get(`/admin/history?site=${site}`).then(r => r.data),
  restore: (hid) => client.post(`/admin/history/restore/${hid}`).then(r => r.data),
  exportAll: (site = "refuge") => client.get(`/admin/export?site=${site}`).then(r => r.data),
};
